import { FC, memo } from 'react'

import { Loader } from '@cash-me/react-components'

import * as S from './styles'

export const PageLoader: FC = memo(() => (
  <S.WrapperLoading>
    <Loader color="primary" size="lg" loaderBackground="var(--colors-neutral-background-default)" />
  </S.WrapperLoading>
))

PageLoader.displayName = 'PageLoader'
